import { FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';

export interface PageNavigationHeaderItem {
  text: string;
  fontWeight?: FontWeights;
  fontSize?: FontSizes;
  onClickFunction?: Function;
}

export const MAX_HEADER_ITEM_LENGTH = 20;

/**
 * Truncate the text if it is too long
 * @param text
 */
export function getTruncatedText(text: string): string {
  const ellipsis = ' ... ';

  // If the text is too long, truncate it and add ellipsis in the middle
  if (text.length > MAX_HEADER_ITEM_LENGTH * 2 + ellipsis.length) {
    return (
      text.substring(0, MAX_HEADER_ITEM_LENGTH) +
      ellipsis +
      text.substring(text.length - MAX_HEADER_ITEM_LENGTH, text.length)
    );
  }

  return text;
}
